import type { Toast } from './types.ts';
import { createSelector } from '../createSelector.ts';

export const toastSelector = createSelector<Toast[]>('toasts.toasts', []);